import { Injectable } from "@angular/core";
import { AccountPass } from "./account-pass";
import { CreditCard } from "./credit-card";
import { Payment } from "./payment";
import { Credit } from "./credit";
import * as moment from "moment";

@Injectable()
export class User {
  public customerIndex =
    Number.parseInt(localStorage.getItem("customerIndex")) || 0;
  public accountIndex = 0;
  public accountSummaryArray;
  public accountPassArray = Array<AccountPass>();
  public creditCardArray = Array<CreditCard>();
  public paymentHistoryArray = Array<Payment>();
  public creditHistoryArray = Array<Credit>();
  public accountDetailsList: any = {};
  public creditCardId: string;

  constructor(
    public userName: string,
    public email: string,
    public tokenKey: string,
    public businessName: string,
    public portfolioIds: number,
    public customerIdArray,
    public emailConfirmed: boolean,
    public isCustomerService: boolean,
    public group: string
  ) {
    this.userName = userName.trim();
    if (customerIdArray && this.customerIndex > customerIdArray.length)
      this.customerIndex = 0;
  }

  addPass(
    id: string,
    name: string,
    passType: string,
    passNumber: string,
    closedDt: string,
    evExpiryDt: string,
    description?: string,
  ) {
    const accountPass: AccountPass = new AccountPass();
    accountPass.id = id;
    accountPass.name = name;
    accountPass.passType = passType;
    accountPass.passNumber = passNumber;
    accountPass.closedDt = closedDt;
    description ? (accountPass.description = description) : "";
    evExpiryDt ? (accountPass.evExpiryDt = evExpiryDt) : null;
    this.accountPassArray.push(accountPass);
  }

  deletePass(index) {
    if (index !== -1) {
      this.accountPassArray.splice(index, 1);
    }
  }

  addPayment(
    id: string,
    cardNumber: string,
    paymentDate: string,
    paymentAmount: number,
    authCode: string
  ) {
    const payment: Payment = new Payment();
    var momentDate = moment(paymentDate);
    const paymentTime = momentDate.format("h:mm A");

    payment.id = id;
    if (cardNumber != "dbt") {
      payment.cardNumber = cardNumber;
    } else {
      payment.cardNumber = "";
    }
    payment.paymentDate = momentDate.format("M/D/YYYY");
    payment.paymentTime = paymentTime;
    payment.amountPaid = paymentAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    payment.authCode = authCode.replace(/^[^|]*\|([^|]*).*$/, "$1"); // grab the second col: 09099F|538251193|Approved|0 -> 538251193

    this.paymentHistoryArray.push(payment);
  }

  addCredit(
    id: string,
    creditDate: string,
    creditAmount: number,
    creditType: string
  ) {
    let creditTime: string;
    let creditDateArray = Array();
    if (creditDate.indexOf(" ") > -1) {
      creditDateArray = creditDate.split(" ");
      creditTime = creditDateArray[1] + creditDateArray[2];
      creditDate = creditDateArray[0];
    } else {
      creditTime = moment(creditDate).format("h:mm A");
      creditDate = moment(creditDate).format("MM/D/YYYY");
    }

    const credit: Credit = new Credit();
    credit.id = id;
    credit.creditTime = creditTime;
    credit.creditDate = creditDate;
    credit.creditAmount = creditAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    credit.creditType = creditType;

    if (credit.creditType.trim() == 'Signup 10 Free Trip Bonus' || credit.creditType.trim() == 'User Referred Signed Up Bonus') {

      credit.creditAmount = credit.creditAmount.split('.')[0].replace('$','') + ' Trips'
    }

    this.creditHistoryArray.push(credit);
  }

  addCreditCard(
    id: string,
    cardNumber: string,
    expiryDate: string,
    cvv: string,
    isPrimary: boolean,
    token: string
  ) {
    const creditCard: CreditCard = new CreditCard();
    creditCard.id = id;
    creditCard.cardNumber = "XXXX XXXX XXXX " + cardNumber;
    creditCard.expiryDate = expiryDate;
    creditCard.cvv = cvv;
    creditCard.isPrimary = isPrimary;
    creditCard.token = token;

    this.creditCardArray.push(creditCard);
  }

  setCustomerIndex(index: number) {
    this.customerIndex = index;
    console.log("setting customer index: " + index);
    localStorage.setItem("customerIndex", index.toString());
  }

  deleteCreditCard(index) {
    if (index !== -1) {
      this.creditCardArray.splice(index, 1);
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/models/user.ts